// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const CvssModifiedPrivilegesRequiredSchema = z.enum(['X','N','L','H'] as const);

export type CvssModifiedPrivilegesRequiredType = `${z.infer<typeof CvssModifiedPrivilegesRequiredSchema>}`

export default CvssModifiedPrivilegesRequiredSchema;
